import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45check_45global from "/app/middleware/auth-check.global.ts";
import auth_45mobile_45global from "/app/middleware/auth-mobile.global.ts";
import locale_45query_45global from "/app/middleware/locale-query.global.ts";
import logo_45text_45global from "/app/middleware/logoText.global.ts";
import mobile_45layout_45global from "/app/middleware/mobile-layout.global.ts";
import password_45change_45check_45global from "/app/middleware/password-change-check.global.ts";
import user_45images_45global from "/app/middleware/userImages.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45check_45global,
  auth_45mobile_45global,
  locale_45query_45global,
  logo_45text_45global,
  mobile_45layout_45global,
  password_45change_45check_45global,
  user_45images_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}